import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle, Loader2 } from 'lucide-react';

const PaymentSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [verifying, setVerifying] = useState(true);
  
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Simulate verification delay
    setTimeout(() => {
      setVerifying(false);
    }, 2000);
  }, []);

  if (verifying) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <Card className="w-full max-w-md">
          <CardContent className="pt-6">
            <div className="flex flex-col items-center text-center space-y-4">
              <Loader2 className="h-16 w-16 text-teal-600 animate-spin" />
              <h2 className="text-xl font-semibold">Zahlung wird verarbeitet...</h2>
              <p className="text-gray-600">Bitte warten Sie einen Moment.</p>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <CheckCircle className="h-20 w-20 text-green-600" />
          </div>
          <CardTitle className="text-2xl font-bold text-green-600">
            Zahlung erfolgreich!
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="text-center space-y-2">
            <p className="text-gray-700">
              Ihre Zahlung wurde erfolgreich verarbeitet.
            </p>
            <p className="text-gray-600">
              Die Punkte wurden Ihrem Konto gutgeschrieben.
            </p>
            {sessionId && (
              <p className="text-xs text-gray-500 mt-4">
                Session ID: {sessionId}
              </p>
            )}
          </div>

          <div className="flex gap-3">
            <Button 
              variant="outline" 
              className="flex-1"
              onClick={() => navigate('/customers')}
            >
              Zu Kunden
            </Button>
            <Button 
              className="flex-1"
              onClick={() => navigate('/products')}
            >
              Weitere Pakete
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentSuccessPage;
